import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import "./App.css";
import Login from "./Components/Login/Login";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Header from "./Components/Header/Header";
import Sidebar from "./Components/Sidebar/Sidebar";
import ActiveAlarms from "./Components/Alarms/ActiveAlarms";
import { Box, CssBaseline } from "@mui/material";
import Assets from "./Components/Devices/Devices";
import Telemetry, { TelemetryWrapper } from "./Components/Telemetry/Telemetry";
import AlarmsMigrated from "./features/Alarms/Alarms";
// import YardView from "./Components/YardView/YardView";
import HistoryTable from "./Components/Telemetry/HistoryTable";
import User from "./Components/User/User";
import AssetsProvider from "./Components/Devices/AssetsProvider";
import YardLayout from "./Components/YardView/YardLayout/YardLayout";
import FormCreator from "./Components/FormCreator/FormCreator";
import Forms from "./Components/FormCreator/Forms/Forms";
import AssetScheduleAssignment from "./Components/Schedule Aseet assignment/AssetScheduleAssignment";
import AssetAssignmentForm from "./Components/Schedule Aseet assignment/ASSET ASSIGNMENT FORM/AssetAssignmentForm";
import FormAssignment from "./Components/Form Assignment/FormAssignment";
import AssignmentForm from "./Components/Form Assignment/AssignmentForm/AssignmentForm";
import AssetTransfer from "./features/AssetTransfer/AssetTransfer";
import { useGetAlarmTypesQuery, useGetDeviceTypesQuery } from "./features/SearchFilters/searchFiltersSlice";
import AlarmRulesView from "./features/AlarmRules/Components/ViewAllRules/ViewAllRules";
import AlarmRulesForm from "./features/AlarmRules/Components/CreateOrEditRule/CreateOrEditRule";
import MigratedDashBoard from "./Components/MIGRATED DASHBOARD/MigratedDashBoard";
import Reports from "./Components/REPORTS/Reports";
import MaintenanceResponseTable from "./Components/Devices/Maintenance/Maintenance Records/MaintenanceResponseTable";
import AssetRegister from "./Components/Devices/AssetRegister/NewRegister";
import AssetMaintenanceHistory from "./Components/Devices/Maintenance/Maintenance Records/Asset Maintenance History/AssetMaintenanceHistory";
import AssetMaintenanceResponses from "./Components/Devices/Maintenance/Maintenance Records/Maintenance Assets Response/AssetMaintenanceResponses";
import AssetUtilization from "./Components/Asset Utilisation/AssetUtilization";
import CustomerGroup from "./features/CustomerGroup/CustomerGroup";
import SFR from "./Components/SFR/SFR";
import SfrForm from "./Components/SFR/SFR FORM/SfrForm";
import SetAttribute from "./Components/YardView/YardLayout/Constant/SetAttribute";
import { useSelector } from "react-redux";
import NewYardLayout from "./Components/NEW YARD LAYOUT/NewYardLayout";
import { isLoggedInSelector } from "./features/authentication/auth-slice";
import AlarmNotificationInfo from "./Components/alarm-notification-info/AlarmNotificationInfo";
import { useShowNotifications } from "./hooks/alarms/show-notifications";
import AssetGis from "./Assets Gis/AssetGis";
import CableMonitoring from "./Components/cable-monitoring/CableMonitoring";

import "antd/dist/antd.css";
import CableMonitoringHistory from "./Components/cable-monitoring/CableMonitoringHistory";
import HealthMonitoring from "./Components/health-monitoring/HealthMonitoring";
import Trend from "./Components/Trend/Trend";
import TrendHistoryTable from "./Components/Trend/TrendHistoryTable";
import PointOperationChartWrapper from "./Components/Telemetry/PointOperationChart/PointOperationChartWrapper";
import AlarmTimelineView from "./features/Alarms/AlarmTimelineView";
import AuditLog from "./features/AuditLog/AuditLog";
import AdminPanel from "./features/AdminPanel";
import ScheduledReportsManagement from "./features/AdminPanel/ScheduledReportsManagement/ScheduledReportsManagement";
import ScheduledReportsTemplates from "./features/AdminPanel/ScheduledReportsManagement/ScheduledReportsTemplates";
import ScheduledReportsSubscriptions from "./features/AdminPanel/ScheduledReportsManagement/ScheduledReportsSubscriptions";
import LayoutPlaybackWrapper from "./Components/NEW YARD LAYOUT/layout-playback/LayoutPlayback";
import DeviceTypeManagement from "./features/AdminPanel/DeviceTypeManagement/DeviceTypeManagement";
import CustomerManagement from "./features/AdminPanel/CustomerManagement/CustomerManagement";
import DeviceKeysManagement from "./features/AdminPanel/DeviceKeys/DeviceKeysManagement";
import DfccilDashboard from "./Components/DFCCIL Dashboard/DfccilDashboard";

import CodalLifeExpiredAsset from "./Components/MIS Reports/CodalLifeExpiredAsset";
import MidlifeRehabilitation from "./Components/MIS Reports/MidlifeRehabilitation";
import MaintenanceOverdue from "./Components/MIS Reports/MaintenanceOverdue";
import SFRReports from "./Components/MIS Reports/SFRReports";
import UnhealthyAssetReport from "./Components/MIS Reports/UnhealthyAssetReport";
import JointInspectionAssignmentForm from "./Components/Form Assignment/AssignmentForm/JointInspectionAssignmentForm";
import JointInspectionHistory from "./Components/JointInspection/JointInspectionHistory";
import JointInspection from "./Components/JointInspection/JointInspection";
import JointInspectionResponses from "./Components/JointInspection/JointInspectionResponse";
import PcdoWrapper from "./Components/PCDO/PcdoWrapper";
import McdoContainer from "./Components/Mcdo/McdoContainer";
import EmployeeBioData from "./Components/Mcdo/EmployeeBiodata/EmployeeBiodata";
import EmployeeBiodataHistory from "./Components/Mcdo/EmployeeBiodata/EmployeeBiodataHistory";
import GeoFencing from "./Components/Geofencing/GeoFencing";
import NewSidebar from "./Components/NewSidebar/NewSidebar";
import theme from "./theme";
import { useEffect, useLayoutEffect } from "react";
import { selectedExtentedSidebar } from "./Components/NewSidebar/sidebarSlice";
import MisReports from "./Components/MIS Reports/MisReports";
import SystemConfigurationManagement from "./features/AdminPanel/SystemConfiguration/SystemConfigurationManagement";
import UnifiedAlarmDashboard from "./Components/Unified-alarm-dashboard/UnifiedAlarmDashboard";
import SystemDashboard from "./Components/system-dashboard/SystemDashboard";
import TMMSDashboard from "./Components/Tmms-dashboard/TMMSDashboard";
import TypicalDrawingStorageContainer from "./Components/Typical-Drawing-Storage";
import LatestInstructionGuidelineContainer from "./Components/Latest-Instruction-Guideline";
import PCCLStorageContainer from "./Components/PCCLStorageDocument";
import NotificationManagement from "./features/AdminPanel/NotificationManagement/NotificationManagement";
import RoleModuleManagement from "./features/AdminPanel/RoleModuleAccess/RoleModuleAccessManagement";
import PlatformSvg from "./Components/PlatformSvg/PlatformSvg";
import KavachDashboard from "./Components/Kavach-dashboard/KavachDashboard";
import KavachSwitchHistory from "./Components/Kavach-dashboard/components/KavachSwitchHistory";
import KavachSwitchDetail from "./Components/Kavach-dashboard/components/KavachSwitchDetail";
import VoIPDashboard from "./Components/VoIP-dashboard/VoIPDashboard";
import VoIPDeviceHistory from "./Components/VoIP-dashboard/components/VoIPDeviceHistory";
import SMPSDashboard from "./Components/SMPS-dashboard/SMPSDashboard";
import SMPSDeviceHistory from "./Components/SMPS-dashboard/components/SMPSDeviceHistory";
import SMPSDeviceDetail from "./Components/SMPS-dashboard/components/SMPSDeviceDetail";
import CCTVDashboard from "./Components/CCTV-dashboard/CCTVDashboard";
import CCTVCameraHistory from "./Components/CCTV-dashboard/components/CCTVCameraHistory";
import HealthMonitoringManagement from "./features/AdminPanel/HealthMonitoringManagement/HealthMonitoringManagement";

// const theme = createTheme();
// const theme = createTheme({
//   palette: {
//     primary: {
//       light: '#28345a',
//       main: '#3f50b5',
//       dark: '#002884',
//       contrastText: '#fff',
//     },
//     // secondary: {
//     //   light: '#ff7961',
//     //   main: '#f44336',
//     //   dark: '#ba000d',
//     //   contrastText: '#000',
//     // },
//   },
// });

declare global {
  interface Window {
    refreshToken: string | null;
    frontendAccess: any;
    userId: string;
    runtimeUrlConfig: any;
    jwtToken: string | null;
    pcdo_url: any;
  }
}

var refreshToken = localStorage.getItem("refresh_token");
window.refreshToken = refreshToken;
let frontendAccess = localStorage.getItem("frontendAccess");
if (frontendAccess) frontendAccess = JSON.parse(frontendAccess);
window.frontendAccess = frontendAccess ?? {};

window.userId = localStorage.getItem("userId") ?? "";

type AccessRouteProps = {
  access: string;
  children: JSX.Element;
};

const AccessRoute = ({ access, children }: AccessRouteProps) => {
  const _frontendAccess = window.frontendAccess;
  const _read = _frontendAccess[access];
  const allowAccess = _read?.readSelf !== false || _read?.readAll !== false;
  if (!allowAccess) return <Navigate to="/" />;
  return children;
};

const App = () => {
  const location = useLocation()
  const loggedIn = useSelector(isLoggedInSelector);
  const extentedSidebar = useSelector(selectedExtentedSidebar);
  useGetDeviceTypesQuery(null);
  useGetAlarmTypesQuery(null);

  useShowNotifications();

  useLayoutEffect(() => {
    function updateSize() {
      const pageWrapper = document.getElementById('page-wrapper-box');
      const totalWidthComp = document.getElementById('main-app-box-without-header');
      const totalWidth = totalWidthComp?.getBoundingClientRect()?.width;
      if (totalWidth && pageWrapper) {
        pageWrapper.style.width = extentedSidebar ? totalWidth - 230 + 'px' : totalWidth - 85 + 'px'
      }
    }
    window.addEventListener('resize', updateSize);
    updateSize()
  }, [extentedSidebar, location])

  return (
    <ActiveAlarms isUserLoggedIn={loggedIn}>
      <ThemeProvider theme={theme}>
        <Box id="main-app-box" className="flex fullViewHeight fullWidth">
          <CssBaseline />
          {/* {isLoading ? <Loader /> : null} */}
          {loggedIn ? (
            <>
              <div id='main-app-box-without-header' className="flex fullWidth fullHeight">
                <NewSidebar />
                {/* <Sidebar /> */}
                <div id="page-wrapper-box" className="page-wrapper fullHeight">
                  <Header />
                  <div className="component-page fullWidth">
                    <Routes>
                      {/* <Route path="/" element={<MigratedDashBoard />} />
                      <Route path="/home" element={<MigratedDashBoard />} />
                      <Route path="/dashboard" element={<MigratedDashBoard />} /> */}
                      <Route path="/" element={<UnifiedAlarmDashboard />} />
                      <Route path="/home" element={<UnifiedAlarmDashboard />} />
                      <Route path="/dashboard" element={<UnifiedAlarmDashboard />} />
                      <Route path="/system-alarm-dashboard" element={<SystemDashboard />} />
                      <Route path="/tmms-dashboard" element={<TMMSDashboard />} />
                      <Route path="/kavach-dashboard" element={<KavachDashboard />} />
                      <Route path="/kavach-switch-history/:id" element={<KavachSwitchHistory />} />
                      <Route path="/kavach-switch-history" element={<KavachSwitchHistory />} />
                      <Route path="/kavach-switch-detail" element={<KavachSwitchDetail />} />
                      <Route path="/voip-dashboard" element={<VoIPDashboard />} />
                      <Route path="/voip-device-history/:id" element={<VoIPDeviceHistory />} />
                      <Route path="/voip-device-history" element={<VoIPDeviceHistory />} />
                      <Route path="/smps-dashboard" element={<SMPSDashboard />} />
                      <Route path="/smps-device-history/:id" element={<SMPSDeviceHistory />} />
                      <Route path="/smps-device-history" element={<SMPSDeviceHistory />} />
                      <Route path="/smps-device-detail" element={<SMPSDeviceDetail />} />
                      <Route path="/cctv-dashboard" element={<CCTVDashboard />} />
                      <Route path="/cctv-camera-history/:id" element={<CCTVCameraHistory />} />
                      <Route path="/cctv-camera-history" element={<CCTVCameraHistory />} />
                      {/* <Route path="/tmms-dashboard" element={<DfccilDashboard />} /> */}
                      {/* <Route path="/mis-home" element={<DfccilDashboard />} /> */}
                      <Route
                        path="/alarms"
                        element={
                          <AccessRoute access="ALARM">
                            <AlarmsMigrated />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/timeline"
                        element={
                          <AccessRoute access="ALARM">
                            <AlarmTimelineView />
                          </AccessRoute>
                        }
                      />
                      <Route path="/" element={<AssetsProvider />}>
                        <Route
                          path="assets"
                          element={
                            <AccessRoute access="ASSET">
                              <Assets />
                            </AccessRoute>
                          }
                        />
                        <Route
                          path="/asset-register"
                          element={
                            <AccessRoute access="ASSET">
                              <AssetRegister />
                            </AccessRoute>
                          }
                        />
                      </Route>
                      <Route
                        path="/maintenance-records"
                        element={
                          <AccessRoute access="ASSET">
                            <MaintenanceResponseTable />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/maintenanace-history"
                        element={
                          <AccessRoute access="ASSET">
                            <AssetMaintenanceHistory />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/maintenanace-responses"
                        element={
                          <AccessRoute access="ASSET">
                            <AssetMaintenanceResponses />
                          </AccessRoute>
                        }
                      />

                      <Route
                        path="/document-management"
                        element={
                          <AccessRoute access="DOCUMENT_MANAGEMENT">
                            <Outlet />
                          </AccessRoute>
                        }
                      >
                        <Route path="typical-drawing-storage" element={<TypicalDrawingStorageContainer />} />
                        <Route path="latest-instruction-guideline" element={<LatestInstructionGuidelineContainer />} />
                        <Route path="pccl-storage" element={<PCCLStorageContainer />} />
                      </Route>

                      <Route
                        path="/pcdo"
                        element={
                          <AccessRoute access="PCDO">
                            <PcdoWrapper />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/mis-reports"
                        element={
                          <AccessRoute access="MIS_REPORTS">
                            <MisReports />
                          </AccessRoute>
                        }
                      />

                      <Route path="/telemetry/:id" element={<TelemetryWrapper />} />
                      {/* <Route path="/telemetry" element={<Telemetry />} /> */}
                      <Route path="/telemetry/point-operation-chart" element={<PointOperationChartWrapper />} />
                      <Route path="/trend" element={<Trend />} />
                      {/* <Route path="/yard-view" element={<YardLayout />} /> */}
                      <Route path="telemetry/cable-history/:id" element={<CableMonitoringHistory />} />
                      <Route path="/telemetry-history/:id" element={<HistoryTable />} />
                      <Route path="/trend-history/:id" element={<TrendHistoryTable />} />

                      <Route path="/yard-view" element={<NewYardLayout />} />
                      <Route path="/playback" element={<LayoutPlaybackWrapper />} />
                      <Route
                        path="/user"
                        element={
                          <AccessRoute access="USER">
                            <User />
                          </AccessRoute>
                        }
                      />
                      <Route path="/geofencing" element={<GeoFencing />} />

                      <Route path="/form-creator" element={<FormCreator />} />
                      <Route
                        path="/forms/:id"
                        element={
                          <AccessRoute access="FORM">
                            <Forms />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/form-assignment"
                        element={
                          <AccessRoute access="FORM_ASSIGNMENT">
                            <FormAssignment />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/joint-inspection-assignment-form"
                        element={
                          <AccessRoute access="FORM_ASSIGNMENT">
                            <JointInspectionAssignmentForm />
                          </AccessRoute>
                        }
                      />

                      <Route
                        path="/joint-inspection"
                        element={
                          <AccessRoute access="JOINT_INSPECTION">
                            <JointInspection />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/joint-inspection-history"
                        element={
                          <AccessRoute access="JOINT_INSPECTION">
                            <JointInspectionHistory />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/joint-inspection-responses"
                        element={
                          <AccessRoute access="JOINT_INSPECTION">
                            <JointInspectionResponses />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/station-group"
                        element={
                          <AccessRoute access="FORM_ASSIGNMENT">
                            <CustomerGroup />
                          </AccessRoute>
                        }
                      />

                      <Route path="/assignment-form" element={<AssignmentForm />} />
                      <Route
                        path="/asset-assignment"
                        element={
                          <AccessRoute access="ASSET_ASSIGNMENT">
                            <AssetScheduleAssignment />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/asset-assignment-form"
                        element={
                          <AccessRoute access="ASSET_ASSIGNMENT">
                            <AssetAssignmentForm />
                          </AccessRoute>
                        }
                      />

                      <Route
                        path="/codal-life-expired-asset"
                        element={
                          <AccessRoute access="MIS">
                            <CodalLifeExpiredAsset />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/midlife-rehabilitation"
                        element={
                          <AccessRoute access="MIS">
                            <MidlifeRehabilitation />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/maintenance-overdue"
                        element={
                          <AccessRoute access="MIS">
                            <MaintenanceOverdue />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/maintenance-deficiency"
                        element={
                          <AccessRoute access="MIS">
                            <UnhealthyAssetReport />
                          </AccessRoute>
                        }
                      />
                      <Route
                        path="/sfr-reports"
                        element={
                          <AccessRoute access="MIS">
                            <SFRReports />
                          </AccessRoute>
                        }
                      />

                      <Route
                        path="/"
                        element={
                          <AccessRoute access="BIODATA">
                            <McdoContainer />
                          </AccessRoute>
                        }
                      >
                        <Route path="employeebiodata" element={<EmployeeBioData />} />
                        <Route path="employeebiodatahistory/:id" element={<EmployeeBiodataHistory />} />
                      </Route>

                      {/* <Route path="/asset-transfer" element={<AssetTransfer />}></Route> */}
                      <Route path="/audit-log" element={<AuditLog />}></Route>
                      <Route path="/reports" element={<Reports />} />
                      <Route path="/platform-alarms" element={<PlatformSvg />} />
                      <Route path="/reports/:id" element={<Reports />} />
                      <Route path="/utilization/:id" element={<AssetUtilization />} />
                      <Route path="/alarm-rules" element={<AlarmRulesView />} />
                      <Route path="/alarm-rules/create" element={<AlarmRulesForm />} />
                      <Route path="/alarm-rules/edit" element={<AlarmRulesForm />} />
                      <Route path="/station-group" element={<CustomerGroup />} />
                      <Route path="/failure-report" element={<SFR />} />
                      <Route path="/TFR-form" element={<SfrForm />} />
                      <Route path="/setAtt" element={<SetAttribute />} />
                      <Route path="/gis" element={<AssetGis />} />
                      <Route path="/health-monitoring" element={<HealthMonitoring />} />
                      <Route
                        path="admin-panel"
                        element={
                          <AccessRoute access="ADMIN">
                            <Outlet />
                          </AccessRoute>
                        }
                      >
                        <Route index element={<AdminPanel />} />
                        <Route path="system" element={<SystemConfigurationManagement />} />
                        <Route path="device-type-management" element={<DeviceTypeManagement />} />
                        <Route path="customer-management" element={<CustomerManagement />} />
                        <Route path="device-keys-management" element={<DeviceKeysManagement />} />
                        <Route path="notification-management" element={<NotificationManagement />} />
                        <Route path="role-module-access" element={<RoleModuleManagement />} />
                        <Route path="health-monitoring-management" element={<HealthMonitoringManagement />} />
                        <Route path="scheduled-reports-management" element={<ScheduledReportsManagement />}>
                          <Route path="templates" element={<ScheduledReportsTemplates />} />
                          <Route path="subscriptions" element={<ScheduledReportsSubscriptions />} />
                          <Route path="*" element={<Navigate to=".." />} />
                        </Route>
                      </Route>
                      {/* <Route path="cable-monitoring" element={<CableMonitoring />}></Route> */}
                    </Routes>
                  </div>
                  <AlarmNotificationInfo />
                </div>
              </div>
            </>
          ) : (
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          )}
        </Box>
      </ThemeProvider>
    </ActiveAlarms>
  );
};

export default App;
